import { root } from './oauth';

export const oauth = {
  ...root,
};
